import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-overlay-side-panel-header',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        display: flex;
        flex: none;
        align-items: center;
        justify-content: space-between;
        height: 6rem;
        padding: 1.8rem 2rem 1.8rem 3.8rem;
        background: var(--white);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlaySidePanelHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
